import React from 'react';
import { connect } from 'react-redux';

import { attSubPage } from 'decorators/subPage';
import {
  startSwitchAttToSprint,
  confirmSwitchAttToSprint,
} from 'actions/attSubs';
import StartSwitchToSprint from './StartSwitchToSprint';
import ConfirmSwitchToSprint from './ConfirmSwitchToSprint';

const getCurrentPage = (props) => {
  const {
    location: { pathname },
  } = props;
  const pathnames = pathname.split('/');

  return pathnames[pathnames.length - 1];
};

const SwitchToSprint = (props) => {
  if (getCurrentPage(props) === 'start-switch-to-sprint') {
    return <StartSwitchToSprint {...props} />;
  }

  if (getCurrentPage(props) === 'confirm-switch-to-sprint') {
    return <ConfirmSwitchToSprint {...props} />;
  }
};

const mapDispatchToProps = {
  startSwitchAttToSprint,
  confirmSwitchAttToSprint,
};

export default attSubPage(connect(null, mapDispatchToProps)(SwitchToSprint));
